import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const TicketFilters = ({ 
  searchQuery, 
  onSearchChange, 
  sortBy, 
  onSortChange, 
  statusFilter, 
  onStatusFilterChange,
  eventTypeFilter,
  onEventTypeFilterChange,
  onClearFilters 
}) => {
  const sortOptions = [
    { value: 'date-asc', label: 'Event Date (Earliest First)' },
    { value: 'date-desc', label: 'Event Date (Latest First)' },
    { value: 'purchase-desc', label: 'Recently Purchased' },
    { value: 'purchase-asc', label: 'Oldest Purchases' },
    { value: 'name-asc', label: 'Event Name (A-Z)' },
    { value: 'name-desc', label: 'Event Name (Z-A)' }
  ];

  const statusOptions = [
    { value: 'all', label: 'All Tickets' },
    { value: 'active', label: 'Active Tickets' },
    { value: 'used', label: 'Used Tickets' },
    { value: 'expired', label: 'Expired Tickets' }
  ];

  const eventTypeOptions = [
    { value: 'all', label: 'All Event Types' },
    { value: 'concert', label: 'Concerts' },
    { value: 'sports', label: 'Sports' },
    { value: 'theater', label: 'Theater' },
    { value: 'comedy', label: 'Comedy' },
    { value: 'conference', label: 'Conferences' },
    { value: 'festival', label: 'Festivals' },
    { value: 'other', label: 'Other Events' }
  ];

  const hasActiveFilters = searchQuery || sortBy !== 'date-asc' || statusFilter !== 'all' || eventTypeFilter !== 'all';

  return (
    <div className="bg-card border border-border rounded-lg p-4 mb-6">
      {/* Search */}
      <div className="mb-4">
        <Input
          type="search"
          placeholder="Search events, venues, or order numbers..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e?.target?.value)}
          className="w-full"
        />
      </div>
      {/* Filters Row */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
        <Select
          label="Sort by"
          options={sortOptions}
          value={sortBy}
          onChange={onSortChange}
        />

        <Select
          label="Status"
          options={statusOptions}
          value={statusFilter}
          onChange={onStatusFilterChange}
        />

        <Select
          label="Event Type"
          options={eventTypeOptions}
          value={eventTypeFilter}
          onChange={onEventTypeFilterChange}
        />

        <div className="flex items-end">
          {hasActiveFilters && (
            <Button
              variant="outline"
              size="sm"
              onClick={onClearFilters}
              iconName="X"
              className="w-full"
            >
              Clear Filters
            </Button>
          )}
        </div>
      </div>
      {/* Active Filters Display */}
      {hasActiveFilters && (
        <div className="flex flex-wrap gap-2 pt-3 border-t border-border">
          <span className="text-sm text-muted-foreground">Active filters:</span>
          
          {searchQuery && (
            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-primary/10 text-primary">
              Search: "{searchQuery}"
              <button
                onClick={() => onSearchChange('')}
                className="ml-1 hover:text-primary/80"
              >
                <Icon name="X" size={12} />
              </button>
            </span>
          )}
          
          {statusFilter !== 'all' && (
            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-primary/10 text-primary">
              Status: {statusOptions?.find(opt => opt?.value === statusFilter)?.label}
              <button
                onClick={() => onStatusFilterChange('all')}
                className="ml-1 hover:text-primary/80"
              >
                <Icon name="X" size={12} />
              </button>
            </span>
          )}
          
          {eventTypeFilter !== 'all' && (
            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-primary/10 text-primary">
              Type: {eventTypeOptions?.find(opt => opt?.value === eventTypeFilter)?.label}
              <button
                onClick={() => onEventTypeFilterChange('all')}
                className="ml-1 hover:text-primary/80"
              >
                <Icon name="X" size={12} />
              </button>
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default TicketFilters;